module.exports = __webpack_public_path__ + "img/db.14619c74.svg";